<template>
    <div class="d-flex">
        <div v-if="showReplyButton" class="mr-4">
            <v-btn icon color="primary" @click="sendReply">
                <v-icon>mdi-reply-all-outline</v-icon>
            </v-btn>
        </div>

        <div class="flex-grow-1">
            <div class="flex-column">
                <div class="d-flex align-baseline">
                    <div class="font-weight-bold">
                        <slot name="title">{{ post.name }}</slot>
                    </div>
                    <div class="text--disabled ml-1" style="font-size: smaller; white-space: nowrap;">{{ Date.newFull(post.created).yyyymmdd() }}</div>
                </div>
                <div>{{ post.comment }} <a v-if="showEditButton" @click="editPost">{{ $translate('Edit') }}</a></div>
            </div>
        </div>

        <TeamsportPlayerPoolUserPostDialog
            v-model="showEditDialog"
            :post="post"
            :teamsports="teamsports"
            :add="false"
            v-if="showEditDialog"
        />

        <TeamsportPlayerPoolReplyDialog
            v-model="showReplyDialog"
            :post="post"
            :type="type"
            :groups="groups"
            v-if="showReplyDialog"
        />
    </div>
</template>

<script>
import TeamsportPlayerPoolUserPostDialog from './TeamsportPlayerPoolUserPostDialog.vue'
import TeamsportPlayerPoolReplyDialog from './TeamsportPlayerPoolReplyDialog.vue'
export default {
    name: 'zoezi-teamsport-player-pool-post',
    props: {
        type: {
            type: String // user, team or usergrouprequest
        },
        showReplyButton: {
            type: Boolean,
        },
        showEditButton: {
            type: Boolean,
        },
        post: {
            type: Object
        },
        teamsports: {
            type: Array
        },
        groups: {
            type: Array
        }
    },

    components: {
        TeamsportPlayerPoolUserPostDialog,
        TeamsportPlayerPoolReplyDialog
    },

    data: () => ({
        showEditDialog: false,
        showReplyDialog: false
    }),

    methods: {
        sendReply() {
            this.showReplyDialog = true
        },
        editPost() {
            this.showEditDialog = true
        }
    }
}
</script>
